import React, { useState } from 'react'
import { Panel, Message, Row, Col } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
import ManageProjectStatusForm from './ManageConsiderationRoundForm'
import ManageProjectStatusTable from './ManageConsiderationRoundTable'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import {
  deleteManagementRound,
  getManagementProjectStatus,
  getManagementProjectStatusPage,
  saveManagementRound,
  searchManagementRound,
  updateManagementProjectStatus,
  updateManagementRound,
} from '../../redux/actions/adminProjectManagemant'
import ProjectInfoView from '../projectBasicInfo/ProjectInfoView'
import PopupModal from '../../components/modal/PopupModal'
import ManageConsiderationRoundTable from './ManageConsiderationRoundTable'
import ManageConsiderationRoundForm from './ManageConsiderationRoundForm'
import reactScrollToComponent from 'react-scroll-to-component'
import ConfirmWidget from '../confirm/ConfirmWidget'
import ButtonPanel from '../ButtonPanel'
import { ERR_MSG } from '../../constants/msgText'
import { SAVE_ERR_MSG } from '../../constants/msgText'
import { DELETE_ERR_MSG } from '../../constants/msgText'
import { DATE_PICKER_FORMAT } from '../../constants/date'
import moment from 'moment'
import { SEARCH_ERR_MSG } from '../../constants/msgText'

export default function ManageConsiderationRoundWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props?.schema)
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)

  const [errorMsg, setErrorMsg] = useState()
  const [searcgErrorMsg, setSearcgErrorMsg] = useState()

  const [isLoading, setIsLoading] = useState()
  const [isDelete, setIsDelete] = useState()
  const [selectedObj, setSelectedObj] = useState()
  const [isAddEite, setIsAddEite] = useState()
  const [dataList, setDataList] = useState(props?.schema?.dataList)
  const [pageNumber, setPageNumber] = useState()
  const [pageSize, setPageSize] = useState()

  const handleSave = async (id, request) => {
    startLoading()
    setIsLoading(true)
    setErrorMsg('')
    try {
      let response

      console.log('ID : ', id, 'REQUEST : ', request)
      if (id) {
        response = await updateManagementRound(id, request)
      } else {
        response = await saveManagementRound(request)
      }

      setDataList(response)
      setIsAddEite(false)
    } catch (e) {
      setErrorMsg(e?.response?.data?.errors?.message || SAVE_ERR_MSG)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data => ', data)
    const req = {
      roundName: data.roundName,
      startDate: data?.startDate ? moment(data.startDate).format(DATE_PICKER_FORMAT) : null,
      endDate: data?.endDate ? moment(data.endDate).format(DATE_PICKER_FORMAT) : null,
      description: data.description,
    }

    handleSave(selectedObj?.id, req)
  }

  const onAdd = () => {
    setSelectedObj('')
    setIsAddEite(true)
  }

  const onDelete = async (id) => {
    console.log('id => ', id)
    setIsLoading(true)
    startLoading()
    try {
      const response = await deleteManagementRound(id)
      console.log('response : ', response)
      setDataList(response)
    } catch (e) {
      console.log('error', e)
      setErrorMsg(e?.response?.data?.errors?.message || DELETE_ERR_MSG)
    }
    setSelectedObj('')
    setIsDelete(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleOnConfirmDelete = () => {
    console.log('handleOnConfirmDelete')
    onDelete(selectedObj.id)
  }

  const handleSearch = async (req, page, displayLength) => {
    setIsLoading(true)
    startLoading()
    try {
      const request = {
        pageSize: displayLength,
        pageNumber: page,
        roundName: req?.roundName,
        startDate: req?.startDate ? moment(req.startDate).format(DATE_PICKER_FORMAT) : null,
        endDate: req?.endDate ? moment(req.endDate).format(DATE_PICKER_FORMAT) : null,
      }
      console.log('request : ', JSON.stringify(request))
      const response = await searchManagementRound(request)
      setPageNumber(page)
      setPageSize(displayLength)

      setDataList(response)
    } catch (e) {
      setSearcgErrorMsg(e?.response?.data?.errors?.message || SEARCH_ERR_MSG)
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.header}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isAddEite ? (
          <>
            <ManageConsiderationRoundForm
              schema={formSchema.inputForm}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              editObj={selectedObj}
              minStartDate={dataList?.values?.[0]?.endDate}
            />
            <hr />
            {errorMsg && (
              <Message style={{ marginBottom: 10 }} showIcon type="error" description={errorMsg} />
            )}

            <SaveButton
              disabled={isLoading}
              onClick={handleSubmit(onSubmit)}
            >{`บันทึก`}</SaveButton>
            <CancelButton
              disabled={isLoading}
              onClick={() => {
                setErrorMsg('')
                setIsDelete(false)
                setIsAddEite(false)
              }}
            >{`ยกเลิก`}</CancelButton>
          </>
        ) : (
          <>
            <ManageConsiderationRoundTable
              schema={dataList}
              displayLength={pageNumber}
              page={pageSize}
              errorMsg={searcgErrorMsg}
              onAdd={onAdd}
              onSelect={(obj) => {
                setSelectedObj(obj)
                setIsDelete(false)
                setIsAddEite(true)
              }}
              onDelete={(obj) => {
                setSelectedObj(obj)
                setIsDelete(true)
                setIsAddEite(false)
              }}
              handleSearch={handleSearch}
            />
          </>
        )}
      </Panel>

      <ConfirmWidget
        size="sm"
        title={`ยื่นยันการลบ`}
        show={isDelete}
        detail={
          <>
            ยื่นยันการลบ <b>{selectedObj?.roundName}</b>
          </>
        }
        onCancle={() => {
          setSelectedObj('')
          setIsDelete(false)
        }}
        onConfirm={handleOnConfirmDelete}
      />
    </>
  )
}
